import React, { useState, useEffect } from 'react';

const LOADING_MESSAGES = [
  "Analyzing your request...",
  "Processing information...",
  "Reviewing your query...",
  "Gathering relevant data...",
  "Preparing your response...",
  "Evaluating options...",
  "Compiling information...",
  "Checking details...",
  "Formulating an answer...",
  "Examining possibilities...",
  "Conducting analysis...",
  "Retrieving insights...",
  "Organizing findings...",
  "Finalizing response...",
  "Cross-referencing data...",
  "Synthesizing information...",
  "Building your answer...",
  "Verifying details...",
  "Structuring response...",
  "Almost ready..."
];

const LoadingMessage: React.FC = () => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % LOADING_MESSAGES.length);
    }, 5000); // Change message every 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex justify-center">
      <div className="bg-white rounded-jobesta shadow-jobesta-card px-6 py-4">
        <div className="flex flex-col items-center space-y-3">
          <div className="flex items-center space-x-2">
            <div className="animate-bounce h-2 w-2 bg-jobesta-blue rounded-full"></div>
            <div className="animate-bounce h-2 w-2 bg-jobesta-blue rounded-full delay-100"></div>
            <div className="animate-bounce h-2 w-2 bg-jobesta-blue rounded-full delay-200"></div>
          </div>
          <div className="text-center">
            <p className="text-jobesta-gray-90 font-medium transition-opacity duration-300">
              {LOADING_MESSAGES[currentMessageIndex]}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingMessage;
